const { default: server } = require("./server");

export const getAllHiringApi = async () => {
  const response = await server().get("/hiringRequests");

  return response.data;
};

export const getSingleHiringApi = async (id) => {
  const response = await server().get(`/hiringRequests/${id}`);

  return response.data;
};

export const deleteSingleHiringApi = async (id) => {
  const response = await server().delete(`/hiringRequests/${id}`);

  return response.data;
};
